/**
 * Minimal ABI for HyperliquidGridStrategy: updateParams (proposer-callable
 * entrypoint) + maxOrdersPerTick getter for read-side chunking.
 */
export const HYPERLIQUID_GRID_STRATEGY_ABI = [
  {
    type: 'function',
    name: 'updateParams',
    inputs: [{ name: 'data', type: 'bytes' }],
    outputs: [],
    stateMutability: 'nonpayable',
  },
  {
    type: 'function',
    name: 'maxOrdersPerTick',
    inputs: [],
    outputs: [{ type: 'uint32' }],
    stateMutability: 'view',
  },
  {
    // Registers the clone with HyperCore so ERC-20 USDC transfers auto-credit
    // HC spot. Call post-init with variant=1 (FirstStorageSlot) and nonce=0.
    // _initialize() already wrote address(this) to slot 0 (_hcSelf); HC reads
    // it post-block to confirm the contract address.
    type: 'function',
    name: 'finalizeForHyperCore',
    inputs: [
      { name: 'token', type: 'uint64' },
      { name: 'variant', type: 'uint8' },
      { name: 'createNonce', type: 'uint64' },
    ],
    outputs: [],
    stateMutability: 'nonpayable',
  },
] as const;
